<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="1200"
    v-model="dialog"
  >
    <template>
      <v-card v-if="device">
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
          <v-spacer/>
          <v-btn
            @click="handleGetScreenshots"
            style="margin-right: 20px;"
          >
            <v-icon>mdi-sync</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
        <v-card 
          style="margin-bottom: 5px;padding:5px 10px;"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <v-checkbox 
                v-model="device.Snapshot"
                label="Activo"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <v-text-field
                v-if="device.Snapshot"
                v-bind="{ 'outlined' : true}"
                v-model="device.SnapshotInterval"
                label="Intervalo (min)"
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <v-text-field
                v-if="device.Snapshot"
                v-bind="{ 'outlined' : true}"
                v-model="device.SnapshotCountLimit"
                label="Límite capturas"
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <v-text-field
                v-if="device.Snapshot"
                v-bind="{ 'outlined' : true}"
                v-model="device.SnapshotQuality"
                label="Calidad"
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <v-autocomplete
                v-if="device.Snapshot"
                v-model="device.SnapshotOrientation"
                :items="orientations"
                outlined
                dense
                hide-details
                itemText="Name"
                itemValue="ID"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="2"
            >
              <v-btn
                color="red"
                dark
                @click="handleUpdateSnapshotConfig"
                block
              >
                Guardar
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="3"
              v-for="item of screenshots"
              :key="item.id"
            >
              <v-card
                class="mx-auto"
                max-width="344"
                @click="handleOpenURL(item.filePath)"
              >
                <v-img
                  :src="item.thumbPath"
                  height="100%"
                />

                <v-card-subtitle>
                  UTCTime:
                    {{item.utcTimestamp}} ({{convertMin(diffMin(item.utcTimestamp))}})
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        </v-card-text>
        <v-snackbar
          v-model="showAlert"
          :timeout="2000"
          top
        >
          {{ alertMsg }}

          <!--template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template-->
        </v-snackbar>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
    onSyncDevice: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    showAlert: false,
    alertMsg: null,
    screenshots: [],
    loadingScreenshot: false,
    errors: [],
    loading: false,
    loadingGroups: false,
    groups: [],
  }),
  computed: {
    apiURL () {
      return `${process.env.VUE_APP_ENV === 'production' ? 'https' : 'http'}://${process.env.VUE_APP_API_DVIEWCONNECT_URL}`
    },
    hideButtons () {
      return [
        { id: 'Installation', name: 'Pendiente de instalación' },
        { id: 'Closed', name: 'Temporalmente cerrado' },
        { id: 'Recovery', name: 'Recogida' },
        { id: 'Viewing', name: 'Visionado' },
        { id: 'Missing', name: 'Perdido' }
      ]
    },
    token () {
      return localStorage.getItem('jwt')
    },
    orientations () {
      return [{
          ID: 'Landscape',
          Name: 'Horizontal'
        }, {
          ID: 'Portrait',
          Name: 'Vertical'
        }]
    },
  },
  watch: {
    device (v) {
      this.dialog = v ? true : false
    },
    'device.Network' () {
      this.handleGetScreenshots()
    },
    showAlert (v) {
      if (!v) this.alertMsg = null
    },
    alertMsg (v) {
      this.showAlert = v ? true : false
    },
  },
  mounted () {
    this.handleGetScreenshots()
  },
  methods:{
    handleUpdateSnapshotConfig () {
      if (!this.device) return
      const { Snapshot, SnapshotCountLimit, SnapshotInterval, SnapshotOrientation, SnapshotQuality } = this.device
      if (Snapshot === null || SnapshotCountLimit === null || SnapshotInterval === null || SnapshotOrientation === null || SnapshotQuality === null) {
        alert('Error')
        return
      }
      this.loadingScreenshot = true
      const body = { Snapshot, SnapshotCountLimit, SnapshotInterval, SnapshotOrientation, SnapshotQuality }
      axios.patch(`${this.apiURL}/v1/private/brightsign/${this.device.Network}/devices/${this.device.ID}/screenshots?token=${this.token}`, body)
        .then (() => {
          this.alertMsg = 'Actualizado'
          this.loadingScreenshot = false
          this.onSyncDevice(this.device)
        })
        .catch (error => {
          console.log(error)
          alert('error')
          this.loadingScreenshot = false
        })
    },
    handleGetScreenshots () {
      if (!this.device) return
      this.loadingScreenshot = true
      axios.get(`${this.apiURL}/v1/private/brightsign/${this.device.Network}/devices/${this.device.ID}/screenshots?token=${this.token}`)
        .then ((response) => {
          this.screenshots = response.data
          this.loadingScreenshot = true
        })
        .catch (error => {
          console.log(error)
          this.loadingScreenshot = true
        })
    },
    convertMin (v) {
      if (v === null) return null
      if (v === 0) return '0m'
      const d = Math.floor(v / (24 * 60));
      const h = Math.floor((v % (24 * 60)) / 60)
      const m = v % 60

      return `${d ? d+'d ' : ''}${h ? h+'h ' : ''}${m ? m+'m ' : ''}`
    },
    diffMin (v) {
      if (v === null) return
      const utcDate = new Date(v)
      const now = new Date()

      const diffMin = Math.floor((now - utcDate) / 60000)
      return diffMin
    },
    handleClose () {
      this.onClose()
    },
    handleOpenURL(v) {
      window.open(v, '_blank')
    },
  },
}
</script>


